import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider as TProvider } from 'styled-components';
import theme, { Theme } from '../../../theme';
import type { RootState } from '../../../reducers';

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const currentTheme = useSelector(
    (state: RootState) => state.preferences.theme
  );
  // Fall back to the light theme when the stored preference is missing or unknown. Otherwise
  // theme[undefined] is undefined → the provider gets an empty theme → every styled-component reading
  // theme.* throws and the WHOLE app renders blank. This happens on a cold direct page load before
  // preferences finish hydrating, or for a profile whose cached preferences are incomplete.
  const activeTheme = theme[currentTheme] || theme[Theme.light];
  return <TProvider theme={{ ...activeTheme }}>{children}</TProvider>;
};
